// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=js"
// @generated from file warinspace/v2/server_to_client.proto (package warinspace.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BotDifficulty, DeploymentRing, LobbyCloseReason, LobbyVisibility, LoginStatus, NotificationSubject, PlayerState, ProductType, StatId, SurrenderPhase, Team, UpgradePath } from "./common_pb.js";
import { file_warinspace_v2_common } from "./common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file warinspace/v2/server_to_client.proto.
 */
export const file_warinspace_v2_server_to_client: GenFile = /*@__PURE__*/
  fileDesc("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", [file_warinspace_v2_common]);

/**
 * @generated from message warinspace.v2.ServerFrame
 */
export type ServerFrame = Message<"warinspace.v2.ServerFrame"> & {
  /**
   * @generated from field: uint64 tick = 1;
   */
  tick: bigint;

  /**
   * @generated from field: repeated warinspace.v2.ServerMessage messages = 2;
   */
  messages: ServerMessage[];
};

/**
 * Describes the message warinspace.v2.ServerFrame.
 * Use `create(ServerFrameSchema)` to create a new message.
 */
export const ServerFrameSchema: GenMessage<ServerFrame> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 0);

/**
 * @generated from message warinspace.v2.ServerMessage
 */
export type ServerMessage = Message<"warinspace.v2.ServerMessage"> & {
  /**
   * @generated from oneof warinspace.v2.ServerMessage.payload
   */
  payload: {
    /**
     * @generated from field: warinspace.v2.PositionReset position_reset = 1;
     */
    value: PositionReset;
    case: "positionReset";
  } | {
    /**
     * @generated from field: warinspace.v2.EntitySpawn entity_spawn = 2;
     */
    value: EntitySpawn;
    case: "entitySpawn";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityDespawn entity_despawn = 3;
     */
    value: EntityDespawn;
    case: "entityDespawn";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityMove entity_move = 4;
     */
    value: EntityMove;
    case: "entityMove";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityAngle entity_angle = 6;
     */
    value: EntityAngle;
    case: "entityAngle";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityHealth entity_health = 7;
     */
    value: EntityHealth;
    case: "entityHealth";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfHealth self_health = 8;
     */
    value: SelfHealth;
    case: "selfHealth";
  } | {
    /**
     * @generated from field: warinspace.v2.ScrapChange scrap_change = 9;
     */
    value: ScrapChange;
    case: "scrapChange";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfReset self_reset = 10;
     */
    value: SelfReset;
    case: "selfReset";
  } | {
    /**
     * @generated from field: warinspace.v2.Dead dead = 11;
     */
    value: Dead;
    case: "dead";
  } | {
    /**
     * @generated from field: warinspace.v2.Init init = 12;
     */
    value: Init;
    case: "init";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfStateAdd self_state_add = 13;
     */
    value: SelfStateAdd;
    case: "selfStateAdd";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfStateRemove self_state_remove = 14;
     */
    value: SelfStateRemove;
    case: "selfStateRemove";
  } | {
    /**
     * @generated from field: warinspace.v2.OtherStateAdd other_state_add = 15;
     */
    value: OtherStateAdd;
    case: "otherStateAdd";
  } | {
    /**
     * @generated from field: warinspace.v2.OtherStateRemove other_state_remove = 16;
     */
    value: OtherStateRemove;
    case: "otherStateRemove";
  } | {
    /**
     * @generated from field: warinspace.v2.ActiveCooldown active_cooldown = 17;
     */
    value: ActiveCooldown;
    case: "activeCooldown";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfStatChange self_stat_change = 18;
     */
    value: SelfStatChange;
    case: "selfStatChange";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfHitBy self_hit_by = 19;
     */
    value: SelfHitBy;
    case: "selfHitBy";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityHitEntity entity_hit_entity = 20;
     */
    value: EntityHitEntity;
    case: "entityHitEntity";
  } | {
    /**
     * @generated from field: warinspace.v2.EntityMiss entity_miss = 21;
     */
    value: EntityMiss;
    case: "entityMiss";
  } | {
    /**
     * @generated from field: warinspace.v2.Emoji emoji = 22;
     */
    value: Emoji;
    case: "emoji";
  } | {
    /**
     * @generated from field: warinspace.v2.SystemLevel system_level = 23;
     */
    value: SystemLevel;
    case: "systemLevel";
  } | {
    /**
     * @generated from field: warinspace.v2.OtherShipChange other_ship_change = 24;
     */
    value: OtherShipChange;
    case: "otherShipChange";
  } | {
    /**
     * @generated from field: warinspace.v2.WorldSetup world_setup = 25;
     */
    value: WorldSetup;
    case: "worldSetup";
  } | {
    /**
     * @generated from field: warinspace.v2.BaseHp base_hp = 26;
     */
    value: BaseHp;
    case: "baseHp";
  } | {
    /**
     * @generated from field: warinspace.v2.ServerId server_id = 27;
     */
    value: ServerId;
    case: "serverId";
  } | {
    /**
     * @generated from field: warinspace.v2.Leaderboard leaderboard = 28;
     */
    value: Leaderboard;
    case: "leaderboard";
  } | {
    /**
     * @generated from field: warinspace.v2.NameReply name_reply = 29;
     */
    value: NameReply;
    case: "nameReply";
  } | {
    /**
     * @generated from field: warinspace.v2.Pong pong = 30;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: warinspace.v2.NameRemoved name_removed = 31;
     */
    value: NameRemoved;
    case: "nameRemoved";
  } | {
    /**
     * @generated from field: warinspace.v2.Notification notification = 32;
     */
    value: Notification;
    case: "notification";
  } | {
    /**
     * @generated from field: warinspace.v2.ServerPops server_pops = 33;
     */
    value: ServerPops;
    case: "serverPops";
  } | {
    /**
     * @generated from field: warinspace.v2.ServerRestarting server_restarting = 34;
     */
    value: ServerRestarting;
    case: "serverRestarting";
  } | {
    /**
     * @generated from field: warinspace.v2.LoginChange login_change = 36;
     */
    value: LoginChange;
    case: "loginChange";
  } | {
    /**
     * @generated from field: warinspace.v2.AccountSnapshot account_snapshot = 38;
     */
    value: AccountSnapshot;
    case: "accountSnapshot";
  } | {
    /**
     * @generated from field: warinspace.v2.MatchInfo match_info = 39;
     */
    value: MatchInfo;
    case: "matchInfo";
  } | {
    /**
     * @generated from field: warinspace.v2.SuicideBombAway suicide_bomb_away = 40;
     */
    value: SuicideBombAway;
    case: "suicideBombAway";
  } | {
    /**
     * @generated from field: warinspace.v2.ProductList product_list = 41;
     */
    value: ProductList;
    case: "productList";
  } | {
    /**
     * @generated from field: warinspace.v2.Equipment equipment = 42;
     */
    value: Equipment;
    case: "equipment";
  } | {
    /**
     * @generated from field: warinspace.v2.GameModeTimes game_mode_times = 43;
     */
    value: GameModeTimes;
    case: "gameModeTimes";
  } | {
    /**
     * @generated from field: warinspace.v2.FfaTarget ffa_target = 45;
     */
    value: FfaTarget;
    case: "ffaTarget";
  } | {
    /**
     * @generated from field: warinspace.v2.MoneySpentOnUpgrades money_spent_on_upgrades = 47;
     */
    value: MoneySpentOnUpgrades;
    case: "moneySpentOnUpgrades";
  } | {
    /**
     * @generated from field: warinspace.v2.MyRank my_rank = 48;
     */
    value: MyRank;
    case: "myRank";
  } | {
    /**
     * @generated from field: warinspace.v2.ChatMessage chat = 49;
     */
    value: ChatMessage;
    case: "chat";
  } | {
    /**
     * @generated from field: warinspace.v2.ShipChanged ship_changed = 100;
     */
    value: ShipChanged;
    case: "shipChanged";
  } | {
    /**
     * @generated from field: warinspace.v2.ProductsGranted products_granted = 101;
     */
    value: ProductsGranted;
    case: "productsGranted";
  } | {
    /**
     * @generated from field: warinspace.v2.LobbyState lobby_state = 102;
     */
    value: LobbyState;
    case: "lobbyState";
  } | {
    /**
     * @generated from field: warinspace.v2.LobbyList lobby_list = 103;
     */
    value: LobbyList;
    case: "lobbyList";
  } | {
    /**
     * @generated from field: warinspace.v2.LobbyClosed lobby_closed = 104;
     */
    value: LobbyClosed;
    case: "lobbyClosed";
  } | {
    /**
     * @generated from field: warinspace.v2.SurrenderState surrender_state = 105;
     */
    value: SurrenderState;
    case: "surrenderState";
  } | {
    /**
     * @generated from field: warinspace.v2.TeamStats team_stats = 106;
     */
    value: TeamStats;
    case: "teamStats";
  } | {
    /**
     * @generated from field: warinspace.v2.FeatureSet feature_set = 107;
     */
    value: FeatureSet;
    case: "featureSet";
  } | {
    /**
     * @generated from field: warinspace.v2.MatchCountdown match_countdown = 108;
     */
    value: MatchCountdown;
    case: "matchCountdown";
  } | {
    /**
     * @generated from field: warinspace.v2.SelfLoadoutAbilities self_loadout_abilities = 109;
     */
    value: SelfLoadoutAbilities;
    case: "selfLoadoutAbilities";
  } | {
    /**
     * @generated from field: warinspace.v2.ServerBuild server_build = 110;
     */
    value: ServerBuild;
    case: "serverBuild";
  } | {
    /**
     * @generated from field: warinspace.v2.TeamPositions team_positions = 111;
     */
    value: TeamPositions;
    case: "teamPositions";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message warinspace.v2.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 1);

/**
 * @generated from message warinspace.v2.PositionReset
 */
export type PositionReset = Message<"warinspace.v2.PositionReset"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.PositionReset.
 * Use `create(PositionResetSchema)` to create a new message.
 */
export const PositionResetSchema: GenMessage<PositionReset> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 2);

/**
 * @generated from message warinspace.v2.EntitySpawn
 */
export type EntitySpawn = Message<"warinspace.v2.EntitySpawn"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from oneof warinspace.v2.EntitySpawn.body
   */
  body: {
    /**
     * @generated from field: warinspace.v2.PlayerSpawn player = 2;
     */
    value: PlayerSpawn;
    case: "player";
  } | {
    /**
     * @generated from field: warinspace.v2.ScrapSpawn scrap = 3;
     */
    value: ScrapSpawn;
    case: "scrap";
  } | {
    /**
     * @generated from field: warinspace.v2.TurretSpawn turret = 5;
     */
    value: TurretSpawn;
    case: "turret";
  } | {
    /**
     * @generated from field: warinspace.v2.DroneSpawn drone = 7;
     */
    value: DroneSpawn;
    case: "drone";
  } | {
    /**
     * @generated from field: warinspace.v2.SoccerBallSpawn soccer_ball = 8;
     */
    value: SoccerBallSpawn;
    case: "soccerBall";
  } | {
    /**
     * @generated from field: warinspace.v2.ControlPointSpawn control_point = 9;
     */
    value: ControlPointSpawn;
    case: "controlPoint";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message warinspace.v2.EntitySpawn.
 * Use `create(EntitySpawnSchema)` to create a new message.
 */
export const EntitySpawnSchema: GenMessage<EntitySpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 3);

/**
 * @generated from message warinspace.v2.PlayerSpawn
 */
export type PlayerSpawn = Message<"warinspace.v2.PlayerSpawn"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;

  /**
   * @generated from field: float angle_radians = 3;
   */
  angleRadians: number;

  /**
   * @generated from field: int32 health = 4;
   */
  health: number;

  /**
   * @generated from field: int32 max_health = 5;
   */
  maxHealth: number;

  /**
   * @generated from field: uint32 ship_id = 6;
   */
  shipId: number;

  /**
   * @generated from field: repeated uint32 all_path_levels = 7;
   */
  allPathLevels: number[];

  /**
   * @generated from field: warinspace.v2.Cosmetics cosmetics = 8;
   */
  cosmetics?: Cosmetics | undefined;

  /**
   * @generated from field: warinspace.v2.Team team = 9;
   */
  team: Team;

  /**
   * @generated from field: repeated warinspace.v2.PlayerState all_states = 10;
   */
  allStates: PlayerState[];

  /**
   * @generated from field: uint32 name_id = 11;
   */
  nameId: number;
};

/**
 * Describes the message warinspace.v2.PlayerSpawn.
 * Use `create(PlayerSpawnSchema)` to create a new message.
 */
export const PlayerSpawnSchema: GenMessage<PlayerSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 4);

/**
 * @generated from message warinspace.v2.Cosmetics
 */
export type Cosmetics = Message<"warinspace.v2.Cosmetics"> & {
  /**
   * @generated from field: uint32 decal_product_id = 1;
   */
  decalProductId: number;

  /**
   * @generated from field: uint32 trail_product_id = 2;
   */
  trailProductId: number;

  /**
   * @generated from field: uint32 tag_product_id = 3;
   */
  tagProductId: number;

  /**
   * @generated from field: uint32 skin_product_id = 4;
   */
  skinProductId: number;
};

/**
 * Describes the message warinspace.v2.Cosmetics.
 * Use `create(CosmeticsSchema)` to create a new message.
 */
export const CosmeticsSchema: GenMessage<Cosmetics> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 5);

/**
 * @generated from message warinspace.v2.ScrapSpawn
 */
export type ScrapSpawn = Message<"warinspace.v2.ScrapSpawn"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.ScrapSpawn.
 * Use `create(ScrapSpawnSchema)` to create a new message.
 */
export const ScrapSpawnSchema: GenMessage<ScrapSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 6);

/**
 * @generated from message warinspace.v2.TurretSpawn
 */
export type TurretSpawn = Message<"warinspace.v2.TurretSpawn"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;

  /**
   * @generated from field: int32 health = 3;
   */
  health: number;

  /**
   * @generated from field: int32 max_health = 4;
   */
  maxHealth: number;

  /**
   * @generated from field: uint32 turret_type = 5;
   */
  turretType: number;

  /**
   * @generated from field: warinspace.v2.Team team = 6;
   */
  team: Team;
};

/**
 * Describes the message warinspace.v2.TurretSpawn.
 * Use `create(TurretSpawnSchema)` to create a new message.
 */
export const TurretSpawnSchema: GenMessage<TurretSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 7);

/**
 * @generated from message warinspace.v2.DroneSpawn
 */
export type DroneSpawn = Message<"warinspace.v2.DroneSpawn"> & {
  /**
   * @generated from field: uint32 owner_player_id = 1;
   */
  ownerPlayerId: number;

  /**
   * @generated from field: uint32 drone_type = 2;
   */
  droneType: number;
};

/**
 * Describes the message warinspace.v2.DroneSpawn.
 * Use `create(DroneSpawnSchema)` to create a new message.
 */
export const DroneSpawnSchema: GenMessage<DroneSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 8);

/**
 * @generated from message warinspace.v2.SoccerBallSpawn
 */
export type SoccerBallSpawn = Message<"warinspace.v2.SoccerBallSpawn"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.SoccerBallSpawn.
 * Use `create(SoccerBallSpawnSchema)` to create a new message.
 */
export const SoccerBallSpawnSchema: GenMessage<SoccerBallSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 9);

/**
 * @generated from message warinspace.v2.ControlPointSpawn
 */
export type ControlPointSpawn = Message<"warinspace.v2.ControlPointSpawn"> & {
  /**
   * @generated from field: sint32 x = 1;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 2;
   */
  y: number;

  /**
   * @generated from field: uint32 control_point_type = 3;
   */
  controlPointType: number;

  /**
   * @generated from field: sint32 influence = 4;
   */
  influence: number;
};

/**
 * Describes the message warinspace.v2.ControlPointSpawn.
 * Use `create(ControlPointSpawnSchema)` to create a new message.
 */
export const ControlPointSpawnSchema: GenMessage<ControlPointSpawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 10);

/**
 * @generated from message warinspace.v2.EntityDespawn
 */
export type EntityDespawn = Message<"warinspace.v2.EntityDespawn"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;
};

/**
 * Describes the message warinspace.v2.EntityDespawn.
 * Use `create(EntityDespawnSchema)` to create a new message.
 */
export const EntityDespawnSchema: GenMessage<EntityDespawn> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 11);

/**
 * @generated from message warinspace.v2.EntityMove
 */
export type EntityMove = Message<"warinspace.v2.EntityMove"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: sint32 x = 2;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 3;
   */
  y: number;
};

/**
 * Describes the message warinspace.v2.EntityMove.
 * Use `create(EntityMoveSchema)` to create a new message.
 */
export const EntityMoveSchema: GenMessage<EntityMove> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 12);

/**
 * @generated from message warinspace.v2.EntityAngle
 */
export type EntityAngle = Message<"warinspace.v2.EntityAngle"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: float angle_radians = 2;
   */
  angleRadians: number;
};

/**
 * Describes the message warinspace.v2.EntityAngle.
 * Use `create(EntityAngleSchema)` to create a new message.
 */
export const EntityAngleSchema: GenMessage<EntityAngle> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 13);

/**
 * @generated from message warinspace.v2.EntityHealth
 */
export type EntityHealth = Message<"warinspace.v2.EntityHealth"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: int32 health = 2;
   */
  health: number;
};

/**
 * Describes the message warinspace.v2.EntityHealth.
 * Use `create(EntityHealthSchema)` to create a new message.
 */
export const EntityHealthSchema: GenMessage<EntityHealth> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 14);

/**
 * @generated from message warinspace.v2.SelfHealth
 */
export type SelfHealth = Message<"warinspace.v2.SelfHealth"> & {
  /**
   * @generated from field: int32 health = 1;
   */
  health: number;
};

/**
 * Describes the message warinspace.v2.SelfHealth.
 * Use `create(SelfHealthSchema)` to create a new message.
 */
export const SelfHealthSchema: GenMessage<SelfHealth> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 15);

/**
 * @generated from message warinspace.v2.ScrapChange
 */
export type ScrapChange = Message<"warinspace.v2.ScrapChange"> & {
  /**
   * @generated from field: int32 scrap = 1;
   */
  scrap: number;
};

/**
 * Describes the message warinspace.v2.ScrapChange.
 * Use `create(ScrapChangeSchema)` to create a new message.
 */
export const ScrapChangeSchema: GenMessage<ScrapChange> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 16);

/**
 * @generated from message warinspace.v2.SelfReset
 */
export type SelfReset = Message<"warinspace.v2.SelfReset"> & {
};

/**
 * Describes the message warinspace.v2.SelfReset.
 * Use `create(SelfResetSchema)` to create a new message.
 */
export const SelfResetSchema: GenMessage<SelfReset> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 17);

/**
 * @generated from message warinspace.v2.Dead
 */
export type Dead = Message<"warinspace.v2.Dead"> & {
};

/**
 * Describes the message warinspace.v2.Dead.
 * Use `create(DeadSchema)` to create a new message.
 */
export const DeadSchema: GenMessage<Dead> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 18);

/**
 * @generated from message warinspace.v2.Init
 */
export type Init = Message<"warinspace.v2.Init"> & {
  /**
   * @generated from field: warinspace.v2.Team team = 1;
   */
  team: Team;

  /**
   * @generated from field: uint32 self_id = 2;
   */
  selfId: number;

  /**
   * @generated from field: uint32 ship_id = 3;
   */
  shipId: number;

  /**
   * @generated from field: repeated uint32 all_upgrade_levels = 4;
   */
  allUpgradeLevels: number[];
};

/**
 * Describes the message warinspace.v2.Init.
 * Use `create(InitSchema)` to create a new message.
 */
export const InitSchema: GenMessage<Init> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 19);

/**
 * @generated from message warinspace.v2.SelfStateAdd
 */
export type SelfStateAdd = Message<"warinspace.v2.SelfStateAdd"> & {
  /**
   * @generated from field: warinspace.v2.PlayerState state = 1;
   */
  state: PlayerState;
};

/**
 * Describes the message warinspace.v2.SelfStateAdd.
 * Use `create(SelfStateAddSchema)` to create a new message.
 */
export const SelfStateAddSchema: GenMessage<SelfStateAdd> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 20);

/**
 * @generated from message warinspace.v2.SelfStateRemove
 */
export type SelfStateRemove = Message<"warinspace.v2.SelfStateRemove"> & {
  /**
   * @generated from field: warinspace.v2.PlayerState state = 1;
   */
  state: PlayerState;
};

/**
 * Describes the message warinspace.v2.SelfStateRemove.
 * Use `create(SelfStateRemoveSchema)` to create a new message.
 */
export const SelfStateRemoveSchema: GenMessage<SelfStateRemove> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 21);

/**
 * @generated from message warinspace.v2.OtherStateAdd
 */
export type OtherStateAdd = Message<"warinspace.v2.OtherStateAdd"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: warinspace.v2.PlayerState state = 2;
   */
  state: PlayerState;
};

/**
 * Describes the message warinspace.v2.OtherStateAdd.
 * Use `create(OtherStateAddSchema)` to create a new message.
 */
export const OtherStateAddSchema: GenMessage<OtherStateAdd> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 22);

/**
 * @generated from message warinspace.v2.OtherStateRemove
 */
export type OtherStateRemove = Message<"warinspace.v2.OtherStateRemove"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: warinspace.v2.PlayerState state = 2;
   */
  state: PlayerState;
};

/**
 * Describes the message warinspace.v2.OtherStateRemove.
 * Use `create(OtherStateRemoveSchema)` to create a new message.
 */
export const OtherStateRemoveSchema: GenMessage<OtherStateRemove> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 23);

/**
 * @generated from message warinspace.v2.ActiveCooldown
 */
export type ActiveCooldown = Message<"warinspace.v2.ActiveCooldown"> & {
  /**
   * @generated from field: uint32 remaining_ms = 1;
   */
  remainingMs: number;
};

/**
 * Describes the message warinspace.v2.ActiveCooldown.
 * Use `create(ActiveCooldownSchema)` to create a new message.
 */
export const ActiveCooldownSchema: GenMessage<ActiveCooldown> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 24);

/**
 * @generated from message warinspace.v2.SelfStatChange
 */
export type SelfStatChange = Message<"warinspace.v2.SelfStatChange"> & {
  /**
   * @generated from field: warinspace.v2.StatId stat = 1;
   */
  stat: StatId;

  /**
   * @generated from field: float value = 2;
   */
  value: number;
};

/**
 * Describes the message warinspace.v2.SelfStatChange.
 * Use `create(SelfStatChangeSchema)` to create a new message.
 */
export const SelfStatChangeSchema: GenMessage<SelfStatChange> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 25);

/**
 * @generated from message warinspace.v2.SelfLoadoutAbilities
 */
export type SelfLoadoutAbilities = Message<"warinspace.v2.SelfLoadoutAbilities"> & {
  /**
   * @generated from field: repeated uint32 all_ability_ids = 1;
   */
  allAbilityIds: number[];

  /**
   * @generated from field: repeated warinspace.v2.EvolutionAbilities all_evolution_choices = 2;
   */
  allEvolutionChoices: EvolutionAbilities[];
};

/**
 * Describes the message warinspace.v2.SelfLoadoutAbilities.
 * Use `create(SelfLoadoutAbilitiesSchema)` to create a new message.
 */
export const SelfLoadoutAbilitiesSchema: GenMessage<SelfLoadoutAbilities> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 26);

/**
 * @generated from message warinspace.v2.EvolutionAbilities
 */
export type EvolutionAbilities = Message<"warinspace.v2.EvolutionAbilities"> & {
  /**
   * @generated from field: uint32 ship_id = 1;
   */
  shipId: number;

  /**
   * @generated from field: repeated uint32 all_ability_ids = 2;
   */
  allAbilityIds: number[];
};

/**
 * Describes the message warinspace.v2.EvolutionAbilities.
 * Use `create(EvolutionAbilitiesSchema)` to create a new message.
 */
export const EvolutionAbilitiesSchema: GenMessage<EvolutionAbilities> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 27);

/**
 * @generated from message warinspace.v2.SelfHitBy
 */
export type SelfHitBy = Message<"warinspace.v2.SelfHitBy"> & {
  /**
   * @generated from field: uint32 shooter_id = 1;
   */
  shooterId: number;

  /**
   * @generated from field: uint32 shot_type = 2;
   */
  shotType: number;
};

/**
 * Describes the message warinspace.v2.SelfHitBy.
 * Use `create(SelfHitBySchema)` to create a new message.
 */
export const SelfHitBySchema: GenMessage<SelfHitBy> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 28);

/**
 * @generated from message warinspace.v2.EntityHitEntity
 */
export type EntityHitEntity = Message<"warinspace.v2.EntityHitEntity"> & {
  /**
   * @generated from field: uint32 shooter_id = 1;
   */
  shooterId: number;

  /**
   * @generated from field: uint32 target_id = 2;
   */
  targetId: number;

  /**
   * @generated from field: uint32 shot_type = 3;
   */
  shotType: number;
};

/**
 * Describes the message warinspace.v2.EntityHitEntity.
 * Use `create(EntityHitEntitySchema)` to create a new message.
 */
export const EntityHitEntitySchema: GenMessage<EntityHitEntity> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 29);

/**
 * @generated from message warinspace.v2.EntityMiss
 */
export type EntityMiss = Message<"warinspace.v2.EntityMiss"> & {
  /**
   * @generated from field: uint32 shooter_id = 1;
   */
  shooterId: number;

  /**
   * @generated from field: uint32 shot_type = 2;
   */
  shotType: number;
};

/**
 * Describes the message warinspace.v2.EntityMiss.
 * Use `create(EntityMissSchema)` to create a new message.
 */
export const EntityMissSchema: GenMessage<EntityMiss> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 30);

/**
 * @generated from message warinspace.v2.Emoji
 */
export type Emoji = Message<"warinspace.v2.Emoji"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: uint32 emoji_index = 2;
   */
  emojiIndex: number;
};

/**
 * Describes the message warinspace.v2.Emoji.
 * Use `create(EmojiSchema)` to create a new message.
 */
export const EmojiSchema: GenMessage<Emoji> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 31);

/**
 * @generated from message warinspace.v2.SystemLevel
 */
export type SystemLevel = Message<"warinspace.v2.SystemLevel"> & {
  /**
   * @generated from field: warinspace.v2.UpgradePath path = 1;
   */
  path: UpgradePath;

  /**
   * @generated from field: uint32 level = 2;
   */
  level: number;
};

/**
 * Describes the message warinspace.v2.SystemLevel.
 * Use `create(SystemLevelSchema)` to create a new message.
 */
export const SystemLevelSchema: GenMessage<SystemLevel> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 32);

/**
 * @generated from message warinspace.v2.ShipChanged
 */
export type ShipChanged = Message<"warinspace.v2.ShipChanged"> & {
  /**
   * @generated from field: uint32 ship_id = 1;
   */
  shipId: number;
};

/**
 * Describes the message warinspace.v2.ShipChanged.
 * Use `create(ShipChangedSchema)` to create a new message.
 */
export const ShipChangedSchema: GenMessage<ShipChanged> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 33);

/**
 * @generated from message warinspace.v2.OtherShipChange
 */
export type OtherShipChange = Message<"warinspace.v2.OtherShipChange"> & {
  /**
   * @generated from field: uint32 entity_id = 1;
   */
  entityId: number;

  /**
   * @generated from field: uint32 ship_id = 2;
   */
  shipId: number;

  /**
   * @generated from field: uint32 skin_product_id = 3;
   */
  skinProductId: number;
};

/**
 * Describes the message warinspace.v2.OtherShipChange.
 * Use `create(OtherShipChangeSchema)` to create a new message.
 */
export const OtherShipChangeSchema: GenMessage<OtherShipChange> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 34);

/**
 * @generated from message warinspace.v2.WorldSetup
 */
export type WorldSetup = Message<"warinspace.v2.WorldSetup"> & {
  /**
   * @generated from field: float base_angle_radians = 1;
   */
  baseAngleRadians: number;

  /**
   * @generated from field: int32 base_distance = 2;
   */
  baseDistance: number;

  /**
   * @generated from field: float base_rotation_speed = 3;
   */
  baseRotationSpeed: number;

  /**
   * @generated from field: sint32 max_x = 4;
   */
  maxX: number;

  /**
   * @generated from field: sint32 max_y = 5;
   */
  maxY: number;

  /**
   * @generated from field: bool ffa = 6;
   */
  ffa: boolean;

  /**
   * @generated from field: bool line_of_sight = 7;
   */
  lineOfSight: boolean;

  /**
   * @generated from field: bool chat_enabled = 8;
   */
  chatEnabled: boolean;

  /**
   * @generated from field: int32 respawn_delay_ms = 9;
   */
  respawnDelayMs: number;

  /**
   * @generated from field: int32 base_max_health = 10;
   */
  baseMaxHealth: number;
};

/**
 * Describes the message warinspace.v2.WorldSetup.
 * Use `create(WorldSetupSchema)` to create a new message.
 */
export const WorldSetupSchema: GenMessage<WorldSetup> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 35);

/**
 * @generated from message warinspace.v2.BaseHp
 */
export type BaseHp = Message<"warinspace.v2.BaseHp"> & {
  /**
   * @generated from field: int32 blue_hp = 1;
   */
  blueHp: number;

  /**
   * @generated from field: int32 red_hp = 2;
   */
  redHp: number;
};

/**
 * Describes the message warinspace.v2.BaseHp.
 * Use `create(BaseHpSchema)` to create a new message.
 */
export const BaseHpSchema: GenMessage<BaseHp> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 36);

/**
 * @generated from message warinspace.v2.ServerId
 */
export type ServerId = Message<"warinspace.v2.ServerId"> & {
  /**
   * @generated from field: uint32 server_num = 1;
   */
  serverNum: number;
};

/**
 * Describes the message warinspace.v2.ServerId.
 * Use `create(ServerIdSchema)` to create a new message.
 */
export const ServerIdSchema: GenMessage<ServerId> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 37);

/**
 * @generated from message warinspace.v2.LeaderboardEntry
 */
export type LeaderboardEntry = Message<"warinspace.v2.LeaderboardEntry"> & {
  /**
   * @generated from field: uint32 name_id = 1;
   */
  nameId: number;

  /**
   * @generated from field: warinspace.v2.Team team = 2;
   */
  team: Team;

  /**
   * @generated from field: int32 points = 3;
   */
  points: number;
};

/**
 * Describes the message warinspace.v2.LeaderboardEntry.
 * Use `create(LeaderboardEntrySchema)` to create a new message.
 */
export const LeaderboardEntrySchema: GenMessage<LeaderboardEntry> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 38);

/**
 * @generated from message warinspace.v2.Leaderboard
 */
export type Leaderboard = Message<"warinspace.v2.Leaderboard"> & {
  /**
   * @generated from field: repeated warinspace.v2.LeaderboardEntry all_entries = 1;
   */
  allEntries: LeaderboardEntry[];
};

/**
 * Describes the message warinspace.v2.Leaderboard.
 * Use `create(LeaderboardSchema)` to create a new message.
 */
export const LeaderboardSchema: GenMessage<Leaderboard> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 39);

/**
 * @generated from message warinspace.v2.NameReply
 */
export type NameReply = Message<"warinspace.v2.NameReply"> & {
  /**
   * @generated from field: uint32 name_id = 1;
   */
  nameId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message warinspace.v2.NameReply.
 * Use `create(NameReplySchema)` to create a new message.
 */
export const NameReplySchema: GenMessage<NameReply> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 40);

/**
 * @generated from message warinspace.v2.Pong
 */
export type Pong = Message<"warinspace.v2.Pong"> & {
  /**
   * @generated from field: uint64 client_nonce = 1;
   */
  clientNonce: bigint;
};

/**
 * Describes the message warinspace.v2.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 41);

/**
 * @generated from message warinspace.v2.NameRemoved
 */
export type NameRemoved = Message<"warinspace.v2.NameRemoved"> & {
  /**
   * @generated from field: uint32 name_id = 1;
   */
  nameId: number;
};

/**
 * Describes the message warinspace.v2.NameRemoved.
 * Use `create(NameRemovedSchema)` to create a new message.
 */
export const NameRemovedSchema: GenMessage<NameRemoved> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 42);

/**
 * @generated from message warinspace.v2.Notification
 */
export type Notification = Message<"warinspace.v2.Notification"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: warinspace.v2.NotificationSubject subject = 2;
   */
  subject: NotificationSubject;
};

/**
 * Describes the message warinspace.v2.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 43);

/**
 * @generated from message warinspace.v2.ServerPops
 */
export type ServerPops = Message<"warinspace.v2.ServerPops"> & {
  /**
   * @generated from field: repeated uint32 all_world_populations = 1;
   */
  allWorldPopulations: number[];
};

/**
 * Describes the message warinspace.v2.ServerPops.
 * Use `create(ServerPopsSchema)` to create a new message.
 */
export const ServerPopsSchema: GenMessage<ServerPops> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 44);

/**
 * @generated from message warinspace.v2.ServerRestarting
 */
export type ServerRestarting = Message<"warinspace.v2.ServerRestarting"> & {
};

/**
 * Describes the message warinspace.v2.ServerRestarting.
 * Use `create(ServerRestartingSchema)` to create a new message.
 */
export const ServerRestartingSchema: GenMessage<ServerRestarting> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 45);

/**
 * @generated from message warinspace.v2.ServerBuild
 */
export type ServerBuild = Message<"warinspace.v2.ServerBuild"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: string commit_sha = 2;
   */
  commitSha: string;
};

/**
 * Describes the message warinspace.v2.ServerBuild.
 * Use `create(ServerBuildSchema)` to create a new message.
 */
export const ServerBuildSchema: GenMessage<ServerBuild> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 46);

/**
 * @generated from message warinspace.v2.LoginChange
 */
export type LoginChange = Message<"warinspace.v2.LoginChange"> & {
  /**
   * @generated from field: warinspace.v2.LoginStatus status = 1;
   */
  status: LoginStatus;

  /**
   * @generated from field: optional uint64 server_account_id = 2;
   */
  serverAccountId?: bigint | undefined;
};

/**
 * Describes the message warinspace.v2.LoginChange.
 * Use `create(LoginChangeSchema)` to create a new message.
 */
export const LoginChangeSchema: GenMessage<LoginChange> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 47);

/**
 * @generated from message warinspace.v2.AccountSnapshot
 */
export type AccountSnapshot = Message<"warinspace.v2.AccountSnapshot"> & {
  /**
   * @generated from field: uint64 credit_balance = 1;
   */
  creditBalance: bigint;

  /**
   * @generated from field: repeated uint32 all_owned_product_ids = 2;
   */
  allOwnedProductIds: number[];
};

/**
 * Describes the message warinspace.v2.AccountSnapshot.
 * Use `create(AccountSnapshotSchema)` to create a new message.
 */
export const AccountSnapshotSchema: GenMessage<AccountSnapshot> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 48);

/**
 * @generated from message warinspace.v2.ProductsGranted
 */
export type ProductsGranted = Message<"warinspace.v2.ProductsGranted"> & {
  /**
   * @generated from field: uint64 credit_balance = 1;
   */
  creditBalance: bigint;

  /**
   * @generated from field: repeated uint32 added_product_ids = 2;
   */
  addedProductIds: number[];
};

/**
 * Describes the message warinspace.v2.ProductsGranted.
 * Use `create(ProductsGrantedSchema)` to create a new message.
 */
export const ProductsGrantedSchema: GenMessage<ProductsGranted> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 49);

/**
 * @generated from message warinspace.v2.MatchInfo
 */
export type MatchInfo = Message<"warinspace.v2.MatchInfo"> & {
  /**
   * @generated from field: sint32 gained_credits = 1;
   */
  gainedCredits: number;

  /**
   * @generated from field: uint32 rank = 2;
   */
  rank: number;

  /**
   * @generated from field: uint32 max_players = 3;
   */
  maxPlayers: number;

  /**
   * @generated from field: uint32 kills = 4;
   */
  kills: number;

  /**
   * @generated from field: uint32 assists = 5;
   */
  assists: number;

  /**
   * @generated from field: uint32 deaths = 6;
   */
  deaths: number;

  /**
   * @generated from field: bool team_swapped = 7;
   */
  teamSwapped: boolean;

  /**
   * @generated from field: bool auto_balanced = 8;
   */
  autoBalanced: boolean;

  /**
   * @generated from field: bool won = 9;
   */
  won: boolean;

  /**
   * @generated from field: uint64 total_heal = 10;
   */
  totalHeal: bigint;

  /**
   * @generated from field: uint64 damage_to_base = 11;
   */
  damageToBase: bigint;

  /**
   * @generated from field: int32 mvp_score = 12;
   */
  mvpScore: number;
};

/**
 * Describes the message warinspace.v2.MatchInfo.
 * Use `create(MatchInfoSchema)` to create a new message.
 */
export const MatchInfoSchema: GenMessage<MatchInfo> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 50);

/**
 * @generated from message warinspace.v2.SuicideBombAway
 */
export type SuicideBombAway = Message<"warinspace.v2.SuicideBombAway"> & {
  /**
   * @generated from field: uint32 drone_id = 1;
   */
  droneId: number;

  /**
   * @generated from field: uint32 target_id = 2;
   */
  targetId: number;

  /**
   * @generated from field: uint32 time_to_hit_ms = 3;
   */
  timeToHitMs: number;
};

/**
 * Describes the message warinspace.v2.SuicideBombAway.
 * Use `create(SuicideBombAwaySchema)` to create a new message.
 */
export const SuicideBombAwaySchema: GenMessage<SuicideBombAway> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 51);

/**
 * @generated from message warinspace.v2.Product
 */
export type Product = Message<"warinspace.v2.Product"> & {
  /**
   * @generated from field: uint32 product_id = 1;
   */
  productId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 price = 3;
   */
  price: number;

  /**
   * @generated from field: warinspace.v2.ProductType product_type = 4;
   */
  productType: ProductType;

  /**
   * @generated from field: string custom_data = 5;
   */
  customData: string;
};

/**
 * Describes the message warinspace.v2.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 52);

/**
 * @generated from message warinspace.v2.ProductList
 */
export type ProductList = Message<"warinspace.v2.ProductList"> & {
  /**
   * @generated from field: repeated warinspace.v2.Product all_products = 1;
   */
  allProducts: Product[];
};

/**
 * Describes the message warinspace.v2.ProductList.
 * Use `create(ProductListSchema)` to create a new message.
 */
export const ProductListSchema: GenMessage<ProductList> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 53);

/**
 * @generated from message warinspace.v2.Equipment
 */
export type Equipment = Message<"warinspace.v2.Equipment"> & {
  /**
   * @generated from field: uint32 decal_product_id = 1;
   */
  decalProductId: number;

  /**
   * @generated from field: uint32 trail_product_id = 2;
   */
  trailProductId: number;

  /**
   * @generated from field: uint32 tag_product_id = 3;
   */
  tagProductId: number;

  /**
   * @generated from field: repeated uint32 all_ship_skin_product_ids = 4;
   */
  allShipSkinProductIds: number[];
};

/**
 * Describes the message warinspace.v2.Equipment.
 * Use `create(EquipmentSchema)` to create a new message.
 */
export const EquipmentSchema: GenMessage<Equipment> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 54);

/**
 * @generated from message warinspace.v2.GameModeTimes
 */
export type GameModeTimes = Message<"warinspace.v2.GameModeTimes"> & {
  /**
   * @generated from field: optional int64 start_delta_ms = 1;
   */
  startDeltaMs?: bigint | undefined;

  /**
   * @generated from field: optional int64 end_delta_ms = 2;
   */
  endDeltaMs?: bigint | undefined;
};

/**
 * Describes the message warinspace.v2.GameModeTimes.
 * Use `create(GameModeTimesSchema)` to create a new message.
 */
export const GameModeTimesSchema: GenMessage<GameModeTimes> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 55);

/**
 * @generated from message warinspace.v2.FfaTarget
 */
export type FfaTarget = Message<"warinspace.v2.FfaTarget"> & {
  /**
   * @generated from field: uint32 player_id = 1;
   */
  playerId: number;
};

/**
 * Describes the message warinspace.v2.FfaTarget.
 * Use `create(FfaTargetSchema)` to create a new message.
 */
export const FfaTargetSchema: GenMessage<FfaTarget> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 56);

/**
 * @generated from message warinspace.v2.MoneySpentOnUpgrades
 */
export type MoneySpentOnUpgrades = Message<"warinspace.v2.MoneySpentOnUpgrades"> & {
  /**
   * @generated from field: uint64 amount = 1;
   */
  amount: bigint;
};

/**
 * Describes the message warinspace.v2.MoneySpentOnUpgrades.
 * Use `create(MoneySpentOnUpgradesSchema)` to create a new message.
 */
export const MoneySpentOnUpgradesSchema: GenMessage<MoneySpentOnUpgrades> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 57);

/**
 * @generated from message warinspace.v2.MyRank
 */
export type MyRank = Message<"warinspace.v2.MyRank"> & {
  /**
   * @generated from field: uint32 rank = 1;
   */
  rank: number;
};

/**
 * Describes the message warinspace.v2.MyRank.
 * Use `create(MyRankSchema)` to create a new message.
 */
export const MyRankSchema: GenMessage<MyRank> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 58);

/**
 * @generated from message warinspace.v2.ChatMessage
 */
export type ChatMessage = Message<"warinspace.v2.ChatMessage"> & {
  /**
   * @generated from field: warinspace.v2.Team team = 1;
   */
  team: Team;

  /**
   * @generated from field: string sender_name = 2;
   */
  senderName: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message warinspace.v2.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 59);

/**
 * @generated from message warinspace.v2.ProfileShip
 */
export type ProfileShip = Message<"warinspace.v2.ProfileShip"> & {
  /**
   * @generated from field: uint32 ship_id = 1;
   */
  shipId: number;

  /**
   * @generated from field: uint32 skin_product_id = 2;
   */
  skinProductId: number;

  /**
   * @generated from field: uint32 decal_product_id = 3;
   */
  decalProductId: number;

  /**
   * @generated from field: uint32 trail_product_id = 4;
   */
  trailProductId: number;

  /**
   * @generated from field: uint32 tag_product_id = 5;
   */
  tagProductId: number;
};

/**
 * Describes the message warinspace.v2.ProfileShip.
 * Use `create(ProfileShipSchema)` to create a new message.
 */
export const ProfileShipSchema: GenMessage<ProfileShip> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 60);

/**
 * @generated from message warinspace.v2.LobbyParticipant
 */
export type LobbyParticipant = Message<"warinspace.v2.LobbyParticipant"> & {
  /**
   * @generated from field: uint32 participant_id = 1;
   */
  participantId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool guest = 3;
   */
  guest: boolean;

  /**
   * @generated from field: warinspace.v2.ProfileShip profile_ship = 4;
   */
  profileShip?: ProfileShip | undefined;
};

/**
 * Describes the message warinspace.v2.LobbyParticipant.
 * Use `create(LobbyParticipantSchema)` to create a new message.
 */
export const LobbyParticipantSchema: GenMessage<LobbyParticipant> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 61);

/**
 * @generated from message warinspace.v2.LobbySeat
 */
export type LobbySeat = Message<"warinspace.v2.LobbySeat"> & {
  /**
   * @generated from field: uint32 slot_id = 1;
   */
  slotId: number;

  /**
   * @generated from field: warinspace.v2.Team team = 2;
   */
  team: Team;

  /**
   * @generated from field: uint32 participant_id = 3;
   */
  participantId: number;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: bool guest = 5;
   */
  guest: boolean;

  /**
   * @generated from field: uint32 ship_id = 6;
   */
  shipId: number;

  /**
   * @generated from field: uint32 skin_product_id = 7;
   */
  skinProductId: number;

  /**
   * @generated from field: warinspace.v2.ProfileShip profile_ship = 8;
   */
  profileShip?: ProfileShip | undefined;
};

/**
 * Describes the message warinspace.v2.LobbySeat.
 * Use `create(LobbySeatSchema)` to create a new message.
 */
export const LobbySeatSchema: GenMessage<LobbySeat> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 62);

/**
 * @generated from message warinspace.v2.LobbyTeamState
 */
export type LobbyTeamState = Message<"warinspace.v2.LobbyTeamState"> & {
  /**
   * @generated from field: warinspace.v2.Team team = 1;
   */
  team: Team;

  /**
   * @generated from field: warinspace.v2.BotDifficulty difficulty = 2;
   */
  difficulty: BotDifficulty;
};

/**
 * Describes the message warinspace.v2.LobbyTeamState.
 * Use `create(LobbyTeamStateSchema)` to create a new message.
 */
export const LobbyTeamStateSchema: GenMessage<LobbyTeamState> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 63);

/**
 * @generated from message warinspace.v2.LobbyState
 */
export type LobbyState = Message<"warinspace.v2.LobbyState"> & {
  /**
   * @generated from field: string join_code = 1;
   */
  joinCode: string;

  /**
   * @generated from field: string name = 9;
   */
  name: string;

  /**
   * @generated from field: string host_name = 2;
   */
  hostName: string;

  /**
   * @generated from field: warinspace.v2.LobbyVisibility visibility = 3;
   */
  visibility: LobbyVisibility;

  /**
   * @generated from field: uint32 host_participant_id = 4;
   */
  hostParticipantId: number;

  /**
   * @generated from field: bool started = 5;
   */
  started: boolean;

  /**
   * @generated from field: repeated warinspace.v2.LobbyTeamState all_teams = 6;
   */
  allTeams: LobbyTeamState[];

  /**
   * @generated from field: repeated warinspace.v2.LobbySeat all_seats = 7;
   */
  allSeats: LobbySeat[];

  /**
   * @generated from field: repeated warinspace.v2.LobbyParticipant all_spectators = 8;
   */
  allSpectators: LobbyParticipant[];

  /**
   * @generated from field: uint32 start_in_ms = 10;
   */
  startInMs: number;
};

/**
 * Describes the message warinspace.v2.LobbyState.
 * Use `create(LobbyStateSchema)` to create a new message.
 */
export const LobbyStateSchema: GenMessage<LobbyState> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 64);

/**
 * @generated from message warinspace.v2.MatchCountdown
 */
export type MatchCountdown = Message<"warinspace.v2.MatchCountdown"> & {
  /**
   * @generated from field: uint32 remaining_ms = 1;
   */
  remainingMs: number;
};

/**
 * Describes the message warinspace.v2.MatchCountdown.
 * Use `create(MatchCountdownSchema)` to create a new message.
 */
export const MatchCountdownSchema: GenMessage<MatchCountdown> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 65);

/**
 * @generated from message warinspace.v2.LobbyListing
 */
export type LobbyListing = Message<"warinspace.v2.LobbyListing"> & {
  /**
   * @generated from field: string join_code = 1;
   */
  joinCode: string;

  /**
   * @generated from field: string name = 8;
   */
  name: string;

  /**
   * @generated from field: string host_name = 2;
   */
  hostName: string;

  /**
   * @generated from field: repeated warinspace.v2.BotDifficulty all_difficulties = 3;
   */
  allDifficulties: BotDifficulty[];

  /**
   * @generated from field: uint32 humans = 4;
   */
  humans: number;

  /**
   * @generated from field: uint32 capacity = 5;
   */
  capacity: number;

  /**
   * @generated from field: uint32 spectators = 6;
   */
  spectators: number;

  /**
   * @generated from field: warinspace.v2.ProfileShip host_profile_ship = 7;
   */
  hostProfileShip?: ProfileShip | undefined;
};

/**
 * Describes the message warinspace.v2.LobbyListing.
 * Use `create(LobbyListingSchema)` to create a new message.
 */
export const LobbyListingSchema: GenMessage<LobbyListing> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 66);

/**
 * @generated from message warinspace.v2.LobbyList
 */
export type LobbyList = Message<"warinspace.v2.LobbyList"> & {
  /**
   * @generated from field: repeated warinspace.v2.LobbyListing all_lobbies = 1;
   */
  allLobbies: LobbyListing[];
};

/**
 * Describes the message warinspace.v2.LobbyList.
 * Use `create(LobbyListSchema)` to create a new message.
 */
export const LobbyListSchema: GenMessage<LobbyList> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 67);

/**
 * @generated from message warinspace.v2.LobbyClosed
 */
export type LobbyClosed = Message<"warinspace.v2.LobbyClosed"> & {
  /**
   * @generated from field: warinspace.v2.LobbyCloseReason reason = 1;
   */
  reason: LobbyCloseReason;
};

/**
 * Describes the message warinspace.v2.LobbyClosed.
 * Use `create(LobbyClosedSchema)` to create a new message.
 */
export const LobbyClosedSchema: GenMessage<LobbyClosed> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 68);

/**
 * @generated from message warinspace.v2.SurrenderState
 */
export type SurrenderState = Message<"warinspace.v2.SurrenderState"> & {
  /**
   * @generated from field: warinspace.v2.SurrenderPhase phase = 1;
   */
  phase: SurrenderPhase;

  /**
   * @generated from field: uint32 yes = 2;
   */
  yes: number;

  /**
   * @generated from field: uint32 no = 3;
   */
  no: number;

  /**
   * @generated from field: uint32 needed = 4;
   */
  needed: number;

  /**
   * @generated from field: uint32 voters = 5;
   */
  voters: number;

  /**
   * @generated from field: uint32 seconds_remaining = 6;
   */
  secondsRemaining: number;

  /**
   * @generated from field: bool you_voted = 7;
   */
  youVoted: boolean;
};

/**
 * Describes the message warinspace.v2.SurrenderState.
 * Use `create(SurrenderStateSchema)` to create a new message.
 */
export const SurrenderStateSchema: GenMessage<SurrenderState> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 69);

/**
 * @generated from message warinspace.v2.TeamStats
 */
export type TeamStats = Message<"warinspace.v2.TeamStats"> & {
  /**
   * @generated from field: uint32 blue_kills = 1;
   */
  blueKills: number;

  /**
   * @generated from field: uint32 red_kills = 2;
   */
  redKills: number;

  /**
   * @generated from field: uint64 blue_scrap_accrued = 3;
   */
  blueScrapAccrued: bigint;

  /**
   * @generated from field: uint64 red_scrap_accrued = 4;
   */
  redScrapAccrued: bigint;
};

/**
 * Describes the message warinspace.v2.TeamStats.
 * Use `create(TeamStatsSchema)` to create a new message.
 */
export const TeamStatsSchema: GenMessage<TeamStats> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 70);

/**
 * @generated from message warinspace.v2.FeatureSet
 */
export type FeatureSet = Message<"warinspace.v2.FeatureSet"> & {
  /**
   * @generated from field: warinspace.v2.DeploymentRing ring = 1;
   */
  ring: DeploymentRing;

  /**
   * @generated from field: repeated warinspace.v2.FeatureFlag all_flags = 2;
   */
  allFlags: FeatureFlag[];
};

/**
 * Describes the message warinspace.v2.FeatureSet.
 * Use `create(FeatureSetSchema)` to create a new message.
 */
export const FeatureSetSchema: GenMessage<FeatureSet> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 71);

/**
 * @generated from message warinspace.v2.FeatureFlag
 */
export type FeatureFlag = Message<"warinspace.v2.FeatureFlag"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: bool overridden = 3;
   */
  overridden: boolean;
};

/**
 * Describes the message warinspace.v2.FeatureFlag.
 * Use `create(FeatureFlagSchema)` to create a new message.
 */
export const FeatureFlagSchema: GenMessage<FeatureFlag> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 72);

/**
 * @generated from message warinspace.v2.TeamPosition
 */
export type TeamPosition = Message<"warinspace.v2.TeamPosition"> & {
  /**
   * @generated from field: uint32 player_id = 1;
   */
  playerId: number;

  /**
   * @generated from field: sint32 x = 2;
   */
  x: number;

  /**
   * @generated from field: sint32 y = 3;
   */
  y: number;

  /**
   * @generated from field: float angle_radians = 4;
   */
  angleRadians: number;

  /**
   * @generated from field: warinspace.v2.Team team = 5;
   */
  team: Team;
};

/**
 * Describes the message warinspace.v2.TeamPosition.
 * Use `create(TeamPositionSchema)` to create a new message.
 */
export const TeamPositionSchema: GenMessage<TeamPosition> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 73);

/**
 * @generated from message warinspace.v2.TeamPositions
 */
export type TeamPositions = Message<"warinspace.v2.TeamPositions"> & {
  /**
   * @generated from field: repeated warinspace.v2.TeamPosition all_positions = 1;
   */
  allPositions: TeamPosition[];
};

/**
 * Describes the message warinspace.v2.TeamPositions.
 * Use `create(TeamPositionsSchema)` to create a new message.
 */
export const TeamPositionsSchema: GenMessage<TeamPositions> = /*@__PURE__*/
  messageDesc(file_warinspace_v2_server_to_client, 74);

